import Vue from 'vue'
import VueRouter from 'vue-router'

import IndexOne from '../pages/indices/Index'
import AnnouncementPage from '../pages/announcement/AnnouncementPage'
import AnnouncementDetailPage from '../pages/announcement/AnnouncementDetailPage'

// TOS
import TOS from '../pages/tos/tos'
import Page404 from '../pages/utilities/Page404'
import GalleryPage from '../pages/GalleryPage'
import TrackingPage from '../pages/TrackingPage'
import config from '../config'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: IndexOne,
    meta: { title: 'E-SEA' }
  },
  {
    path: '/privacy',
    name: 'ToS',
    component: TOS
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: AnnouncementPage,
    meta: { title: 'Pengumuman - E-SEA' }
  },
  {
    path: '/announcement/:slug',
    name: 'announcement-detail',
    component: AnnouncementDetailPage,
    meta: { title: 'Pengumuman - E-SEA' }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryPage,
    meta: { title: 'Galeri - E-SEA' }
  },
  {
    path: '/tracking',
    name: 'tracking',
    component: TrackingPage,
    meta: { title: 'Tracking - E-SEA' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    redirect: '/',
    component: Page404,
    meta: { title: 'Not Found - E-SEA' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const element = document.getElementById(to.meta.anchor)
      if (element) {
        return window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        })
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : 'E-SEA'
  next()
})

export default router
